import { createSelector } from "reselect";
import { TimelycodeStore } from "../../../shared/types";

const selectApp = (state: TimelycodeStore) => state.app;

export const getSocialLinks = () => createSelector(selectApp, state => state.socialLinks);
export const getNotification = () => createSelector(selectApp, state => state.showNotification);
export const getChangeLanguage = () => createSelector(selectApp, state => state.changeLanguage);
